/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'
import auth from '@/auth'

// Routes
import paths from './paths'

function childRoutes(name,path,view)
{
  return {
    name:name,
    path,
    components:{
      nestedMenu: (resovle) => import(
        `@/views/${view}.vue`
      ).then(resovle)
    }
  }
}

function route (path, view, name,children) {
  return {
    name: name || view,
    path,
    beforeEnter: path == '/login' ? "" : path=='/logout' ? logout : requireAuth,
    component: (resovle) => import(
      `@/views/${view}.vue`
    ).then(resovle),
    children:children ? children.map(child=>childRoutes(child.name,child.path,child.view)) : []
  }
}
function requireAuth (to, from, next) {
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

function logout (to, from, next) {
  console.log("logout");
  auth.logout()
  next({
    path: '/login',
  })
}

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name,path.children)).concat([
    { path: '*', redirect: '/dashboard' }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
